/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import colors from 'Styles/colors';

export const FAILED = 'Failed';
export const COMPLETED = 'Completed';
export const RUNNING = 'Running';

const STATUS = {
  [FAILED]: colors.red3,
  [COMPLETED]: colors.green1,
  [RUNNING]: colors.blueCerulean
};

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 20px;
  font-size: 13.5px;
  font-weight: 600;
  font-size: 10px;
  color: ${colors.white};
  background: ${({ status }) => STATUS[status]};
  border-radius: 6px;
  cursor: pointer;
`;
Wrapper.displayName = 'Wrapper';
